<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbAnnuaire"></p-breadcrumb>
</div>
<div class="card mt-4">


    <div class="font-semibold text-xl mb-4">Liste des Annuaires - {{this.nomDo}} - {{this.DO}}</div>
    <p-toolbar styleClass="mb-6">

        <ng-template #start>

            <p-button label="Ajouter" icon="pi pi-plus" severity="primary" class="mr-2" (onClick)="openNew()" />

            <p-button severity="secondary" label="Désactiver" icon="pi pi-times" outlined class="mr-2"
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedAnnuaires || !selectedAnnuaires.length || allSelectedAnnuairesInactive() || hasMixedSelection()"
                (onClick)="disableSelectedAnnuaires()" />

            <p-button severity="secondary" label="Activer" icon="pi pi-check" outlined class="mr-2"
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedAnnuaires || !selectedAnnuaires.length || allSelectedAnnuairesActive() || hasMixedSelection()"
                (onClick)="enableSelectedAnnuaires()" />

            <p-button severity="primary" label="Supprimer" icon="pi pi-trash" class="mr-2"
                [disabled]="!selectedAnnuaires || !selectedAnnuaires.length" (onClick)="deleteSelectedAnnuaires()" />

        </ng-template>

        <ng-template #end>
            <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary" class="mr-2"
                (click)="openUploadDialog()" />
            <p-dialog header="Importation en masse" [(visible)]="UploadDialog" [breakpoints]="{ '960px': '75vw' }"
                [style]="{ width: '30vw' }" [modal]="true">

                <div class="flex flex-col items-center text-center p-4 w-full">

                    <!-- Bouton Export -->
                    <p-button label="Exporter le modèle" icon="pi pi-download" severity="secondary" class="mb-4"
                        (onClick)="telechargerTemplateCSV()">
                    </p-button>

                    <!-- Upload -->
                    <p-fileupload #uploader name="demo[]" [multiple]="true" [accept]="'.csv'" [auto]="false"
                        [customUpload]="true" (uploadHandler)="onUpload($event, uploader)" [maxFileSize]="500000"
                        mode="advanced" uploadLabel="Importer" class="w-full">

                        <!-- Texte d'info quand vide -->
                        <ng-template #empty>
                            <div class="text-sm text-gray-500">
                                Faites glisser et déposez le fichier CSV ici pour l'importer.
                            </div>
                        </ng-template>

                        <!-- Liste des fichiers sélectionnés -->
                        <ng-template #content>
                            <ul *ngIf="uploadedFiles.length" class="mt-2 text-sm">
                                <li *ngFor="let file of uploadedFiles">{{ file.name }} - {{ file.size }} bytes</li>
                            </ul>
                        </ng-template>
                    </p-fileupload>

                    <!-- Radio buttons -->
                    <div class="mt-4">
                        <label class="block font-semibold text-sm mb-2">Voulez-vous écraser les données existantes
                            ?</label>
                        <div class="flex justify-center gap-6">
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="true" [(ngModel)]="add_on"
                                    inputId="noEcrase" />
                                <label for="noEcrase" class="text-sm">Non</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="false" [(ngModel)]="add_on"
                                    inputId="yesEcrase" />
                                <label for="yesEcrase" class="text-sm">Oui</label>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <ng-template #footer>
                    <p-button label="Fermer" icon="pi pi-times" (click)="closeUploadDialog()" class="p-button-text" />
                </ng-template>
            </p-dialog>
            <p-button label="Exporter en CSV" icon="pi pi-download" severity="secondary"
                (onClick)="ExporterAnnuaireCSV()"
                [disabled]="loading || !annuaires || annuaires.length === 0"></p-button>
        </ng-template>
    </p-toolbar>
    <p-table #dt1 [value]="annuaires" dataKey="code_interne" [rows]="10" [rowHover]="true" [showGridlines]="true"
        [paginator]="true" [tableStyle]="{ 'min-width': '75rem' }" [(selection)]="selectedAnnuaires"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} annuaires"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions" exportFilename="annuaires_export"
        [loading]="loading" [globalFilterFields]="[
            'Civilite',
            'nomComplet',
  'fonctionService',
  'Tel1',
  'Tel2',
  'Tel3',
  'TelGSM',
  'AdrEmail',
  'Adresse1'
]" responsiveLayout="scroll">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                    (click)="clear(dt1)"></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher" />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 2rem; font-weight: bold !important; text-align: center; vertical-align: middle;">
                    <p-tableHeaderCheckbox />
                </th>

                <th
                    style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Nom & Prénom</span>
                        <p-columnFilter type="text" field="nomComplet" display="menu"
                            placeholder="Rechercher par nom" />
                    </div>
                </th>

                <th
                    style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Fonction & Service</span>
                        <p-columnFilter type="text" field="fonctionService" display="menu"
                            placeholder="Rechercher par Fonction/Service" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Téléphone 1</span>
                        <p-columnFilter type="text" field="Tel1" display="menu"
                            placeholder="Rechercher par Téléphone 1" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Téléphone 2</span>
                        <p-columnFilter type="text" field="Tel2" display="menu"
                            placeholder="Rechercher par Téléphone 2" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Téléphone 3</span>
                        <p-columnFilter type="text" field="Tel3" display="menu"
                            placeholder="Rechercher par Téléphone 3" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Email</span>
                        <p-columnFilter type="text" field="AdrEmail" display="menu"
                            placeholder="Rechercher par Email" />
                    </div>
                </th>
                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        <span style="font-weight: bold;">Statut</span>
                        <p-columnFilter field="FlagActif" matchMode="equals" display="menu">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-select [ngModel]="value" [options]="statusOptions" (onChange)="filter($event.value)"
                                    placeholder="Rechercher par Statut" [style]="{ 'min-width': '12rem' }">
                                    <ng-template let-option #item>
                                        <span [class]="'customer-badge status-' + option.value">{{ option.label
                                            }}</span>
                                    </ng-template>
                                </p-select>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        <span style="font-weight: bold;">Actions</span>
                    </div>
                </th>
            </tr>

        </ng-template>

        <ng-template #body let-annuaire>
            <tr>
                <td style="text-align: center; vertical-align: middle;">
                    <p-tableCheckbox [value]="annuaire" />
                </td>

                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.Civilite }} {{ annuaire.nomComplet }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.fonctionService }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.Tel1 }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.Tel2 }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.Tel3 }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ annuaire.AdrEmail }}</td>
                <td>
                    <div class="flex items-center justify-center gap-2">
                        <p-toggleSwitch [(ngModel)]="annuaire.FlagActif" (onChange)="onToggleChange(annuaire)"
                            [trueValue]="1" [falseValue]="0" [disabled]="annuaire.toggleLoading" class="scale-90">
                            <ng-template #handle let-checked="checked">
                                <i [ngClass]="{'!text-xs pi': true, 'pi-check': checked, 'pi-times': false}"></i>
                            </ng-template>
                        </p-toggleSwitch>
                        <span class="font-semibold w-20"> {{ annuaire.FlagActif === 1 ? 'Activé' : 'Désactivé' }}</span>
                    </div>
                </td>

                <td class="text-center" style="padding: 0.5rem; vertical-align: middle;">
                    <div class="flex justify-center items-center gap-2">

                        <p-button icon="pi pi-eye" (onClick)="openDetailsAnnuaire(annuaire)" class="mr-1"
                            [rounded]="true" [outlined]="true" />
                        <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true"
                            (click)="editAnnuaire(annuaire)"></p-button>
                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                            (click)="deleteByOne(annuaire)"></p-button>
                    </div>
                </td>
            </tr>

        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="8">Aucun annuaire trouvé.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="8">Chargement des données annuaires. Veuillez patienter.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="ajoutDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Ajouter Annuaire"
        [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">
                <!-- Ligne 1 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [(ngModel)]="DO" disabled class="w-full" />
                    </div>
                <div class="mb-4">
  <label class="block font-bold mb-2">
    Civilité <span class="text-red-500">*</span>
  </label>

  <p-selectButton
    [(ngModel)]="annuaire.Civilite"
    [options]="selectButtonValues"
    optionLabel="name"
    optionValue="value"
    [ngClass]="{ 'p-invalid': civiliteAjoutInvalide }">
  </p-selectButton>

  <small *ngIf="civiliteAjoutInvalide" class="text-red-500">
    La civilité est obligatoire
  </small>
</div>
                </div>

                <!-- Ligne 2 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom<span class="text-red-500">*</span></label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Nom"
                            [ngClass]="{ 'p-invalid': nomAjoutInvalide }" class="w-full" />
                        <small *ngIf="nomAjoutInvalide" class="text-red-500">Le nom est requis</small>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Prenom" class="w-full" />
                    </div>
                </div>

                <!-- Ligne 3 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Fonction" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Service" class="w-full" />
                    </div>
                </div>

                <!-- Assistant -->
                <div>
                    <label class="block font-bold mb-2">Assistant</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Assistant" class="w-full" />
                </div>

                <!-- Adresses -->
                <div>
                    <label class="block font-bold mb-2">Adresse 1</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Adresse1" class="w-full" />
                </div>
                <div>
                    <label class="block font-bold mb-2">Adresse 2</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Adresse2" class="w-full" />
                </div>

                <!-- Code postal et Ville -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.CodePostal" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Ville" class="w-full" />
                    </div>
                </div>

                <!-- Téléphones -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Tel 1</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel1" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 2</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel2" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 3</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel3" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel Privé</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.TelPrivate" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">GSM</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.TelGSM" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Fax" class="w-full" />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block font-bold mb-2">Email <span style="color: red;font-size: smaller;">(Les adresses doivent être séparées par un point-virgule « ; »)</span></label>
                    <input type="email" pInputText [(ngModel)]="annuaire.AdrEmail"
                       class="w-full" />

                </div>

                <!-- Remarque -->
                <div>
                    <label class="block font-bold mb-2">Remarque</label>
                    <textarea pTextarea [(ngModel)]="annuaire.Remarque" rows="3" class="w-full"></textarea>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
            <p-button label="Enregistrer" [disabled]="buttonDisable" icon="pi pi-check" (click)="ajouterAnnuaire(annuaire)" />
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="updateDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Modifier Annuaire"
        [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">
                <!-- Ligne 1 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [(ngModel)]="DO" disabled class="w-full" />
                    </div>
                   <div class="mb-4">
  <label class="block font-bold mb-2">
    Civilité <span class="text-red-500">*</span>
  </label>

  <p-selectButton
    [(ngModel)]="annuaire.Civilite"
    [options]="selectButtonValues"
    optionLabel="name"
    optionValue="value"
    [ngClass]="{ 'p-invalid': civiliteModifInvalide }">
  </p-selectButton>

  <small *ngIf="civiliteModifInvalide" class="text-red-500">
    La civilité est obligatoire
  </small>
</div>
                </div>

                <!-- Ligne 2 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom<span class="text-red-500">*</span></label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Nom"
                            [ngClass]="{ 'p-invalid': nomUpdateInvalide }" class="w-full" />
                        <small *ngIf="nomUpdateInvalide" class="text-red-500">Le nom est requis</small>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Prenom" class="w-full" />
                    </div>
                </div>

                <!-- Ligne 3 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Fonction" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Service" class="w-full" />
                    </div>
                </div>

                <!-- Assistant -->
                <div>
                    <label class="block font-bold mb-2">Assistant</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Assistant" class="w-full" />
                </div>

                <!-- Adresses -->
                <div>
                    <label class="block font-bold mb-2">Adresse 1</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Adresse1" class="w-full" />
                </div>
                <div>
                    <label class="block font-bold mb-2">Adresse 2</label>
                    <input type="text" pInputText [(ngModel)]="annuaire.Adresse2" class="w-full" />
                </div>

                <!-- Code postal et Ville -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.CodePostal" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Ville" class="w-full" />
                    </div>
                </div>

                <!-- Téléphones -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Tel 1</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel1" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 2</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel2" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 3</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Tel3" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel Privé</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.TelPrivate" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">GSM</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.TelGSM" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText [(ngModel)]="annuaire.Fax" class="w-full" />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block font-bold mb-2">Email <span style="color: red;font-size: smaller;">(Les adresses doivent être séparées par un point-virgule « ; »)</span></label>
                    <input type="email" pInputText [(ngModel)]="annuaire.AdrEmail"
                        [ngClass]="{ 'p-invalid': emailUpdateInvalide }" class="w-full" />
                    <small *ngIf="emailUpdateInvalide" class="text-red-500">Format d'email invalide</small>
                </div>

                <!-- Remarque -->
                <div>
                    <label class="block font-bold mb-2">Remarque</label>
                    <textarea pTextarea [(ngModel)]="annuaire.Remarque" rows="3" class="w-full"></textarea>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
            <p-button label="Enregistrer" [disabled]="buttonDisable" icon="pi pi-save" (click)="UpdateAnnuaire(annuaire.code_interne,annuaire)" />
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="DetailsDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Détails Annuaire"
        [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">
                <!-- Ligne 1 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [(ngModel)]="DO" disabled class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Civilité</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Civilite" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 2 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Nom" [readOnly]="true"
                            class="w-full" />

                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Prenom" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 3 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Fonction" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Service" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Assistant -->
                <div>
                    <label class="block font-bold mb-2">Assistant</label>
                    <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Assistant" class="w-full"
                        [readOnly]="true" />
                </div>

                <!-- Adresses -->
                <div>
                    <label class="block font-bold mb-2">Adresse 1</label>
                    <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Adresse1" class="w-full"
                        [readOnly]="true" />
                </div>
                <div>
                    <label class="block font-bold mb-2">Adresse 2</label>
                    <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Adresse2" class="w-full"
                        [readOnly]="true" />
                </div>

                <!-- Code postal et Ville -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.CodePostal" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Ville" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Téléphones -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Tel 1</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Tel1" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 2</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Tel2" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel 3</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Tel3" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Tel Privé</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.TelPrivate" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">GSM</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.TelGSM" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText [(ngModel)]="selectedAnnuaireItem.Fax" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block font-bold mb-2">Email</label>
                    <input type="email" pInputText [(ngModel)]="selectedAnnuaireItem.AdrEmail" [readOnly]="true"
                        class="w-full" />

                </div>

                <!-- Remarque -->
                <div>
                    <label class="block font-bold mb-2">Remarque</label>
                    <textarea pTextarea [(ngModel)]="selectedAnnuaireItem.Remarque" rows="3" class="w-full"
                        [readOnly]="true"></textarea>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />

        </ng-template>
    </p-dialog>

    <p-confirmdialog [style]="{ width: '450px' }" />


    <p-confirmdialog [style]="{ width: '450px' }" />




</div>
<p-toast />
